import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons'

type RedirectToJobButtonProps = {
  jobId: number
}

const RedirectToJobButton = ({ jobId }: RedirectToJobButtonProps) => {
  return (
    <Button
      icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
      onClick={() => window.open(`/#!/job-redirect/${jobId}`, '_blank')}
    >
      View Job
    </Button>
  )
}

export default RedirectToJobButton
